module.exports = "#contabilidaddiv {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 768px; }\n\n#frame {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 768px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminayuda/adminayuda.component.scss
// module id = ./src/app/adminayuda/adminayuda.component.scss
// module chunks = main